export const LOGIN = '/partners';
export const HOME = '/account/:page?';
export const START = '/*';
export const PUBLIC_ROUTES = [LOGIN];
export const PRIVATE_ROUTE = [HOME, START];
